import React from 'react';
import {connect} from 'react-redux';
import EmployeeModel from '/app/src/model/Employee/model';

import {SVGButton, Flex, H3, TextInput, Jibber} from '/app/src/component'
import {ButtonBarLayout} from '/app/src/layoutComponent'

import Validation from '/app/src/lib/Validation'
import style from './style.css'

class ChangePassword extends Jibber{
    //TODO: Validate fields, beautify
    constructor(props){
        super(props);
        this._inputHandler = this._inputHandler.bind(this);
        this._handleSubmitButton = this._handleSubmitButton.bind(this);
        this._validateInput = this._validateInput.bind(this);

        //Textfields
        this.validator = new Validation(['currentPassword', 'newPassword', 'newPassRepeat']);

        //Only display errors after user has submitted.
        this.useState({
            currentPassword: '',
            newPassword: '',
            newPasswordRepeat: '',
            inputIsValid: true,
        })
    }

    _validateInput() {
        const validator = this.validator
        validator.validate(['notEmpty'], 'currentPassword', this.state.currentPassword);
        validator.validate(['notEmpty', 'validPassword'], 'newPassword', this.state.newPassword);
        validator.validate(['notEmpty'], 'newPassRepeat', this.state.newPasswordRepeat);
        validator.validate(['match'], 'newPassRepeat', [this.state.newPasswordRepeat, this.state.newPassword]);
        this.setInputIsValid(validator.allValid());
    }

    _handleSubmitButton() {
        const currentPassword = this.state.currentPassword;
        const newPassword = this.state.newPassword;
        const newPasswordRepeat = this.state.newPasswordRepeat;

        this._validateInput();

        //InputIsValid depends on allValid and is not fully synchronized.
        if (this.validator.allValid()){
            this.props.changePassword(currentPassword, newPassword, newPasswordRepeat);
            this.setState({
                currentPassword: '',
                newPassword: '',
                newPasswordRepeat: '',
                inputIsValid: true,
                changed: false
            })
        }
    }

    _inputHandler(event) {
        this.setState({[event.target.name]: event.target.value, changed: true})
    }

    render() {
        const currentPassword = this.state.currentPassword;
        const newPassword = this.state.newPassword;
        const newPasswordRepeat = this.state.newPasswordRepeat;
        const inputIsValid = this.state.inputIsValid;
        return(
            <Flex w='100%' h='100%' column>
                <ButtonBarLayout>
                    <Flex column>
                        <SVGButton text='Byt lösenord' src='/images/Save.svg' onClick={this._handleSubmitButton} border color='black' hover='blue'
                            disabled={!this.state.changed}
                        />
                        <Flex h='10px' fontSize='12px' fontWeight='400' color='darkgrey' mt='2px'>
                            {this.state.changed && '*Ändringar är inte sparade'}
                        </Flex>
                    </Flex>
                </ButtonBarLayout>

                <Flex w='100%' hAlignContent='center' overflowY='auto'>
                    <Flex width='50%' column maxWidth='400px' minWidth='200px'>
                        <h3 className={style.title}> Byt lösenord </h3>
                        <Flex shrink={0} column marginTop='20px'>
                            <H3 marginBottom='5px'> Befintligt lösenord </H3>
                            <TextInput
                                name='currentPassword'
                                onChange={this._inputHandler}
                                value={currentPassword}
                                placeholder="Befintligt lösenord"
                                autoComplete=''
                                label='Befintligt lösenord'
                                type='password'
                                />
                                <p className={style.errorMessage}> { !inputIsValid && this.validator.errorMsg('currentPassword') } </p>
                        </Flex>
                        <Flex shrink={0} column marginTop='20px'>
                            <H3 marginBottom='5px'> Nytt lösenord </H3>
                            <TextInput
                                name='newPassword'
                                onChange={this._inputHandler}
                                value={newPassword}
                                placeholder="Nytt lösenord"
                                autoComplete=''
                                label='Nytt lösenord'
                                type='password'
                                />
                                <p className={style.errorMessage}> { !inputIsValid && this.validator.errorMsg('newPassword') } </p>
                        </Flex>
                        <Flex shrink={0} column marginTop='20px'>
                            <H3 marginBottom='5px'> Upprepa nytt lösenord </H3>
                            <TextInput
                                name='newPasswordRepeat'
                                onChange={this._inputHandler}
                                value={newPasswordRepeat}
                                placeholder="Upprepa nytt lösenord"
                                autoComplete=''
                                label='Upprepa nytt lösenord'
                                type='password'
                                className={newPassword !== newPasswordRepeat && style.ErrorBorder}
                                />
                                <p className={style.errorMessage}> { !inputIsValid && this.validator.errorMsg('newPassRepeat') } </p>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        );
    }
}


const {selector: changePasswordSelector, dispatcher: changePasswordDispatcher} = EmployeeModel.changePassword()

function mapDispatchToProps(dispatch, props){
    return {
        changePassword: (current, newPass, repeat)=>dispatch(changePasswordDispatcher(current, newPass, repeat))
    }
}

function mapStateToProps(state, props){
    return {
        network: changePasswordSelector(state).network.toJS()
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/UserRoute/ChangePassword/index.js